
import XHeader from 'vux/src/components/x-header/index.vue'
import Toast from 'vux/src/components/toast/index.vue'

import {mapState,mapMutations} from 'vuex'
import { doWithdraw, withdrawInfo, getUserInfo } from '../service/getdata'
export default {
data(){
return{
show:false,
msg:"",
address: "",
actions: [{ name: 'USDT' }, { name: 'ETH' }, { name: 'BTC' }],  //选择提币的币种列表
chainList: [ 'ERC20','TRC20'],  //区块链网络
check: 'ERC20', //选中的区块链网络
coin: "USDT", //选中提的币种
showSymbol: false, //底部选择币种弹出框的展示隐藏
money: "",
paywd: "",
input_type: 'password',
withdrawInfo: {},
userInfo: {},
list: [{
title: "USDT",
key: "USDT"
},{
title: "BTC",
key: "BTC"
},{
title: "ETH",
key: "ETH"
}]
}
},
components:{
XHeader,
Toast
},
created(){
this.SETTOKEN()
this.getData()
},
computed:{
...mapState([ 'token'])
},
methods:{
...mapMutations(['SETTOKEN']),
getData(){
var that = this
this.$Loading()
withdrawInfo({token: this.token}).then(function(res){
var res = res.data;
that.$Loading.close()
if(res.status=='1' || res.status=='0'){
that.withdrawInfo = res.data

}else if(res.status=='-1'){
that.$router.push('/pages/login')
}
}.bind(this),function(){
that.$Loading.close()
console.log("error")
})
getUserInfo({token: this.token}).then(function(res){
var res = res.data;
that.$Loading.close()
if(res.status=='1'){
that.userInfo = res.data

}else if(res.status=='-1'){
that.$router.push('/pages/login')
}
}.bind(this),function(){
that.$Loading.close()

console.log("error")
})
},
all(){
this.money = this.withdrawInfo[this.coin]
},
save(){

if(this.address==''){
this.sendMsg(this.$t("请输入提币地址"))
return
}
if(this.money==''){
this.sendMsg(this.$t("请输入提币数量"))
return
}
if(this.paywd==''){
this.sendMsg(this.$t('请输入支付密码'))
return
}
var that = this
this.$Loading()
doWithdraw({token: this.token, paywd: this.paywd, symbol: this.coin, uid: window.localStorage.getItem("uid"), money: this.money,type:this.check, address: this.address}).then(function(res){
var res = res.data;
that.$Loading.close()
if(res.status=='1'){
that.$vux.alert.show({
title: that.$t("提示"),
content: res.message,
buttonText: that.$t("确定"),
onHide:function(){
that.$router.push("/pages/moneyLog?history=2")

}
})
}else if(res.status=='-1'){
that.$router.push('/pages/login')
}else{
this.sendMsg(res.message)
}
}.bind(this),function(){
that.$Loading.close()

console.log("error")
})
},
onSelect(item) {
this.showSymbol = false;
this.coin = item.name;
},
share(val) {
if (!val) {
return
}
navigator.clipboard.writeText(val).then(() => {
this.sendMsg(this.$t('复制成功'));
})
},
async pastCont() {
this.address = await navigator.clipboard.readText();
},

sendMsg(content) {
this.msg = content;
this.show = true;
}
},
watch: {

coin: {
handler(curVal, oldVal) {
if(this.coin == 'USDT'){
this.chainList = ['ERC20','TRC20']
}else if(this.coin=='BTC'){
this.chainList = ['BTC']
this.check = 'BTC'
}else{
this.chainList = ['ETH']
this.check = "ETH"
}
},
deep: true
}
}
}



// WEBPACK FOOTER //
// ./src/pages/withdrawal.vue